export const DISABLE_TOP_YMAL_PDP = 'disableTopYmalPdp';
export const SOLD_PDP_V1 = 'SoldPDPV1';
export const PDP_REFETCH_OPTIMIZATIONS = 'PdpRefetchOptimizations';
